// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3x3h3","detailsBorder":"styles_detailsBorder__2lDHZ"};